<template>
  <v-container fluid grid-list-xl>
    <!-- Hero -->
    <section id="hero" class="hero hero-modern">
      <div class="content_home">
        <div class="hero-eyebrow">
          <v-chip small outlined color="#ffa409" text-color="#1f2937" class="chip-eyebrow" style="font-size: 18px;font-weight: 400;">
            Nouveau • Plateforme Pro
          </v-chip>
        </div>

        <h1 class="page-title page-title-gradient">
          Protégez votre <span class="accent">entreprise</span>,<br />
          sans <span class="accent">complexité</span>.
        </h1>

        <p class="page-subtitle">
          Identifiez vos risques en 2 minutes et obtenez une recommandation personnalisée.
        </p>

        <div class="cta-group">
           <v-btn
            outlined
            class="cta-btn cta-ghost"
            large
            color="#ffa409"
            @click="openDemandeDemo"
          >
            Faire une demande de devis
            <v-icon right>&#xe85d;</v-icon>
          </v-btn>
          
          <v-btn
            color="#ffa409"
            class="cta-btn cta-primary-white"
            large
            @click="openAssessment"
          >
            Évaluer mes risques maintenant
            <v-icon right>&#xe5c8;</v-icon>
          </v-btn>
        </div>

        <nav class="anchor-nav anchor-chips" role="navigation" aria-label="Ancrages de sections">
          <a href="#why" class="anchor-link" @click.prevent="scrollToSection('why')">
            <v-icon left small>&#xe887;</v-icon> Pourquoi une assurance entreprise ?
          </a>
          <a href="#risks" class="anchor-link" @click.prevent="scrollToSection('risks')">
            <v-icon left small>&#xe002;</v-icon> Les risques
          </a>
          <a href="#offers" class="anchor-link" @click.prevent="scrollToSection('offers')">
            <v-icon left small>&#xe8ef;</v-icon> Nos offres
          </a>
          <a href="#trust" class="anchor-link" @click.prevent="scrollToSection('trust')">
            <v-icon left small>&#xe8dc;</v-icon> Ils nous font confiance
          </a>
          <a href="#contact-pro" class="anchor-link" @click.prevent="scrollToSection('contact-pro')">
            <v-icon left small>&#xf0e2;</v-icon> Contact & Assistance
          </a>
        </nav>
      </div>

      <img class="hero-bg-image" :src="heroImage" alt="" aria-hidden="true" />
      <!-- Glow shapes -->
      <div class="hero-overlay"></div>
      <div class="hero-shape shape-1"></div>
      <div class="hero-shape shape-2"></div>
    </section>

    <!-- Pourquoi Assuraf Pro Online -->
    <section id="why" class="section" style="margin-left: 10%;margin-right: 10%;">
      <div class="section-header">
        <h2>Pourquoi une assurance entreprise ?</h2>
        <div class="underline_bar"></div>
      </div>

      <v-layout row wrap class="margin">
        <v-flex xs12 sm6 md4>
          <div class="benefit-card">
            <v-icon color="#ffa409">&#xef55;</v-icon>
            <h3>Incendie & dégâts des eaux</h3>
            <p>Protéger locaux & stocks</p>
          </div>
        </v-flex>
        <v-flex xs12 sm6 md4>
          <div class="benefit-card">
            <v-icon color="#ffa409">&#xe90e;</v-icon>
            <h3>Responsabilité civile</h3>
            <p>Protéger contre les dommages causés</p>
          </div>
        </v-flex>
        <v-flex xs12 sm6 md4>
          <div class="benefit-card">
            <v-icon color="#ffa409">&#xe32a;</v-icon>
            <h3>Cyber & pertes financières</h3>
            <p>Éviter l’arrêt d’activité</p>
          </div>
        </v-flex>
      </v-layout>
    </section>

    <!-- Risques entreprise -->
    <section id="risks" class="section section-gray">
      <div class="section-header" style="margin-left: 9%;margin-right: 9%;">
        <h2>Les risques clés de votre entreprise</h2>
        <div class="underline_bar"></div>
      </div>

      <v-layout row wrap class="margin" style="margin-left: 9%;margin-right: 9%;">
        <v-flex xs12 sm6 md4 v-for="r in risks" :key="r.slug">
          <v-card class="risk-card" outlined>
            <div class="risk-header">
              <v-icon color="#ffa409">{{ r.icon }}</v-icon>
              <span class="risk-title">{{ r.title }}</span>
            </div>
            <div class="risk-text">{{ r.text }}</div>
          </v-card>
        </v-flex>
        <v-flex xs12 class="text-center mt-4">
          <v-btn
            color="#ffa409"
            class="cta-btn cta-primary-white"
            large
            @click="openAssessment"
          >
            Évaluer mes risques maintenant
            <v-icon right>&#xe5c8;</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </section>

    <!-- Nos offres -->
    <section id="offers" class="section section-gray">
      <div class="section-header" style="margin-left: 9%;margin-right: 9%;">
        <h2>Nos principales assurances pro</h2>
        <div class="underline_bar"></div>
      </div>

      <v-layout row wrap class="margin" style="margin-left: 9%;margin-right: 9%;">
        <v-flex xs12 sm6 md4 v-for="offer in offers" :key="offer.slug">
          <v-card class="offer-card" outlined>
            <v-card-title class="offer-title">
              <v-icon color="#0d4e78" left>{{ offer.icon }}</v-icon>
              <span>{{ offer.name }}</span>
            </v-card-title>
            <v-card-text class="offer-text">
              {{ offer.description }}
            </v-card-text>
            <v-card-actions class="offer-actions">
                <v-btn
                v-show="offer.devisOnline !== false"
                class="offer-btn offer-btn-secondary"
                color="#0d4e78"
                outlined
                @click="toDevis(offer)"
              >
                Faire un devis en ligne
              </v-btn>
              <!-- <v-btn
                class="offer-btn offer-btn-primary"
                color="#ffa409"
                :disabled="!offer.pdfUrl"
                @click="downloadOfferPdf(offer.pdfUrl)"
              >
                Télécharger le questionnaire
              </v-btn> -->
            </v-card-actions>
             <v-card-actions class="offer-actions" style="margin-top: -25px;">
              <v-btn
              v-show="offer.pdfUrl !== ''"
                class="offer-btn offer-btn-primary"
                color="#ffa409"
                :disabled="!offer.pdfUrl"
                @click="downloadOfferPdf(offer.pdfUrl)"
              >
                Télécharger le questionnaire
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </section>

    <!-- Ils nous font confiance -->
    <section id="trust" class="section">
      <!-- <div class="section-header">
        <h2>Ils nous font confiance</h2>
        <div class="underline_bar"></div>
      </div> -->
      <div class="margin">
        <!-- Réutilisation du composant logos partenaires -->
        <partenaire-section type="pro" />
      </div>
    </section>

    <!-- Contact & Assistance -->
    <section id="contact-pro" class="section section-gray">
      <div class="section-header">
        <h2>Contact & Assistance</h2>
        <div class="underline_bar"></div>
      </div>

      <v-layout row wrap class="margin" style="margin-left: 10%;margin-right: 10%;">
        <v-flex xs12 sm6 md4>
          <div class="contact-card">
            <v-icon color="#ffa409">&#xe0cd;</v-icon>
            <h3>Téléphone</h3>
            <p>
              <a href="tel:+221761416464" aria-label="Téléphone Assuraf">
                +221 76 141 64 64
              </a>
            </p>
          </div>
        </v-flex>
        <v-flex xs12 sm6 md4>
          <div class="contact-card">
            <v-icon color="#25D366">&#xe0b7;</v-icon>
            <h3>WhatsApp</h3>
            <p>
              <a
                href="https://wa.me/221761416464?text=Bonjour%20Assuraf%20Pro%20Online"
                target="_blank"
                rel="noopener"
                aria-label="WhatsApp Assuraf"
              >
                +221 76 141 64 64
              </a>
            </p>
          </div>
        </v-flex>
        <v-flex xs12 sm6 md4>
          <div class="contact-card">
            <v-icon color="#0d4e78">&#xe0be;</v-icon>
            <h3>Email</h3>
            <p>
              <a href="mailto:contact@assuraf.com" aria-label="Email Assuraf">
                contact@assuraf.com
              </a>
            </p>
          </div>
        </v-flex>

        <!-- <v-flex xs12 class="text-center mt-4">
          <v-btn color="#ffa409" @click="goToContactForm('Assurance Pro')" style="border-radius: 10px!important;">
            Contacter un conseiller
          </v-btn>
        </v-flex> -->
      </v-layout>
    </section>

    <!-- Dialog: Formulaire Pro -->
    <v-dialog persistent v-model="showProForm" max-width="900" style="border-radius: 20px;">
      <v-card flat class="assessment-card" style="border-radius: 20px!important">
        <template v-if="assessmentMode">
          <div class="assessment">

            <div class="pro-form-card">
              <div class="pro-form-header">
                <div class="header-left">
                  <v-icon color="#ffa409" class="mr-2">&#xe7ee;</v-icon>
                  <div class="titles">
                    <h3 class="title">Évaluation rapide</h3>
                    <p class="subtitle">Découvrez votre profil de risques en 6 questions.</p>
                  </div>
                </div>
                <div class="header-right">
                  <span class="badge">Assuraf Pro Online</span>
                  <v-icon color="#0d4e78" class="close-icon" style="cursor:pointer" @click="showProForm = false">&#xe5cd;</v-icon>
                </div>
              </div>
              <h3 style="margin-top: -10px;" >Question <span>{{ assessment.step + 1 }}/6</span></h3>

              <div class="assessment-header">
                  <v-progress-linear :value="assessmentProgress" color="#ffa409" height="8" rounded style="border-radius:20px"></v-progress-linear>
              </div>

               <div v-if="!assessmentCompleted" class="assessment-body">
              <div class="assessment-question">
                <h4 class="assessment-question-title">{{ currentQuestion.title }}</h4>
                <div class="assessment-options">
                  <v-chip
                    v-for="opt in currentQuestion.options"
                    :key="opt.value"
                    :class="['assessment-chip', { 'chip-selected': isSelected(opt.value) }]"
                    :outlined="!isSelected(opt.value)"
                    @click="selectOption(opt.value)"
                  >
                    <v-icon class="ml-2" left small v-if="opt.icon">{{ opt.icon }}</v-icon>
                    {{ opt.label }}
                  </v-chip>
                </div>
              </div>
              <div class="assessment-actions wizard-actions">
                 <button
                              @click="prevStep"
                              type="button"
                              class="wizard-btn next-btn"
                              :disabled="assessment.step===0" style="font-weight: 500;"
                            >
                             <v-icon>&#xe5c4;</v-icon>
                              <span class="mr-2">Précédent</span>
                            </button>

                <v-spacer></v-spacer>
                 <button
                              @click="nextOrFinish"
                              type="button"
                              class="wizard-btn next-btn"
                              :class="{'next-btn-active': isStep1Complete}"
                              :style="{ color: currentAnswer ? '#ffa409' : '', fontWeight: 500 }"
                              :disabled="!currentAnswer"
                            >
                              <span class="mr-2">{{ assessment.step < 5 ? 'Suivant' : 'Terminer' }}</span>
                              <v-icon :style="{ color: currentAnswer ? '#ffa409' : '' }">&#xe5c8;</v-icon>
                            </button>
              </div>
            </div>
            <div v-else class="assessment-results">
              <h3 class="assessment-results-title">Votre profil de risques : {{ riskProfileLabel }}</h3>
              <div class="results-grid">
                <div class="result-block">
                  <h4 class="result-title">Risques principaux</h4>
                  <div class="result-cards">
                    <div class="result-card" v-for="r in topRisks" :key="r.key">
                      <div class="result-card-header">
                        <v-icon color="#ffa409">{{ r.icon }}</v-icon>
                        <span class="result-card-title">{{ r.title }}</span>
                      </div>
                      <div class="result-card-text">{{ r.micro }}</div>
                    </div>
                  </div>
                </div>
                <div class="result-block">
                  <h4 class="result-title">Garanties recommandées</h4>
                  <div class="chips">
                    <v-chip v-for="g in recommendedGaranties" :key="g" color="#0d4e78" text-color="#fff">{{ g }}</v-chip>
                  </div>
                </div>
                <div class="result-block">
                  <h4 class="result-title">Pack adapté</h4>
                  <div class="chips">
                    <v-chip v-for="p in recommendedPacks" :key="p" color="#ffa409">{{ p }}</v-chip>
                  </div>
                </div>
              </div>
              <div class="assessment-actions result-actions">
                <v-btn class="assessment-btn assessment-btn-primary" color="#ffa409" @click="convertDevis">Demander un devis en 5 minutes</v-btn>
                <v-btn class="assessment-btn assessment-btn-secondary" outlined color="#0d4e78" @click="convertCallback">Être rappelé par un conseiller</v-btn>
                <!-- <v-btn class="assessment-btn assessment-btn-secondary" outlined color="#0d4e78" @click="downloadRecommendation">Télécharger la recommandation PDF</v-btn> -->
              </div>
            </div>
        </div>
           
          </div>
        </template>
        <template v-else>
          <get-devis-from-form :subject="formSubject" @close="showProForm = false" />
        </template>
      </v-card>
    </v-dialog>

     <!-- Dialog: Demande de devis -->
    <v-dialog persistent v-model="demandeDemo" max-width="900" style="border-radius: 20px;">
      <v-card flat class="assessment-card" style="border-radius: 20px!important">
        <template>
          <get-devis-from-form :subject="formSubject" @close="demandeDemo = false" />
        </template>
      </v-card>
    </v-dialog>

    <!-- Footer -->
    <!-- <footer-component /> -->
  </v-container>
</template>

<script>
import partenaireSection from '../home_component/partenaire_section.vue'
import footerComponent from '../footer.vue'
import GetDevisFromForm from './get_devis_from_form.vue'
import offersPro from '../../common/pro_offers.json'
import heroBg from '../../assets/img/plateform/business-work-1.jpg'


export default {
  name: 'AssurafProOnline',
  components: {
    partenaireSection,
    footerComponent,
    GetDevisFromForm
  },
  data: () => ({
    title: 'Assuraf Pro Online | Assurances professionnelles',
    description:
      'Découvrez toutes nos assurances professionnelles en ligne : RC Pro, Multirisque, Flotte Auto, TRC, Caution et plus. Téléchargez les documents et contactez un conseiller.',
    questionnaireUrl: 'https://drive.google.com/file/d/1Pg4HttzMQof2VyjRRp139lQoRPnsuocN/view', // Placez le PDF public ici (ex: '/docs/pro/questionnaire.pdf')
    showProForm: false,
    demandeDemo : false,
    formSubject: 'Assurance Pro',
    offers: offersPro,
    heroImage: heroBg,
    risks: [
      { slug: 'incendie', icon: 'whatshot', title: 'Incendie', text: 'Destruction des biens' },
      { slug: 'eaux', icon: 'invert_colors', title: 'Dégâts des eaux', text: 'Infiltrations et pertes' },
      { slug: 'climat', icon: 'cloud_queue', title: 'Climat', text: 'Intempéries et sinistres' },
      { slug: 'vol', icon: 'shield', title: 'Vol', text: 'Biens dérobés' },
      { slug: 'bris', icon: 'build', title: 'Bris de machine', text: 'Arrêt matériel critique' },
      { slug: 'rc', icon: 'gavel', title: 'Responsabilité civile', text: 'Dommages à des tiers' },
      { slug: 'employe', icon: 'groups', title: 'Risque employé', text: 'Accidents du personnel' },
      { slug: 'cyber', icon: 'security', title: 'Cyber', text: 'Attaques et fuites' },
      { slug: 'transport', icon: 'local_shipping', title: 'Transport', text: 'Pertes en transit' },
      { slug: 'fraude', icon: 'report', title: 'Fraude', text: 'Malversations internes' },
      { slug: 'chantier', icon: 'build', title: 'Chantier', text: 'Incidents sur site' },
      { slug: 'exploitation', icon: 'trending_down', title: "Perte d'exploitation", text: 'Revenus interrompus' }
    ],
    assessmentMode: false,
    assessmentCompleted: false,
    assessment: {
      step: 0,
      answers: {
        sector: null,
        location: null,
        buildings: null,
        data: null,
        personnel: null,
        logistics: null
      }
    },
    riskScores: {},
    riskProfileLabel: ''
  }),
  metaInfo() {
    return {
      title: this.title,
      meta: [
        { charset: 'utf-8' },
        { name: 'description', content: this.description },
        { name: 'robots', content: 'index,follow' }
      ]
    }
  },
  computed: {
    assessmentProgress() {
      return Math.round(((this.assessment.step + 1) / 6) * 100)
    },
    currentQuestion() {
      const steps = [
        { key: 'sector', title: 'Secteur d’activité', options: [
          { value: 'commerce', label: 'Commerce', icon: 'store' },
          { value: 'industrie', label: 'Industrie', icon: 'precision_manufacturing' },
          { value: 'services', label: 'Services', icon: 'work' },
          { value: 'construction', label: 'Construction', icon: 'construction' }
        ] },
        { key: 'location', title: 'Localisation', options: [
          { value: 'urbain', label: 'Urbain', icon: 'location_city' },
          { value: 'cotier', label: 'Côtier', icon: 'waves' },
          { value: 'industriel', label: 'Industriel', icon: 'factory' },
          { value: 'rural', label: 'Rural', icon: 'park' }
        ] },
        { key: 'buildings', title: 'Bâtiments & équipements', options: [
          { value: 'entrepot', label: 'Entrepôt', icon: 'warehouse' },
          { value: 'atelier', label: 'Atelier machines', icon: 'build' },
          { value: 'bureaux', label: 'Bureaux', icon: 'business' },
          { value: 'boutique', label: 'Point de vente', icon: 'shopping_bag' }
        ] },
        { key: 'data', title: 'Données & informatique', options: [
          { value: 'minimal', label: 'Minimal', icon: 'cloud_off' },
          { value: 'standard', label: 'Standard', icon: 'cloud' },
          { value: 'sensible', label: 'Sensible', icon: 'lock' }
        ] },
        { key: 'personnel', title: 'Personnel (effectif)', options: [
          { value: '1-10', label: '1–10', icon: 'group' },
          { value: '11-50', label: '11–50', icon: 'groups' },
          { value: '51-200', label: '51–200', icon: 'diversity_3' },
          { value: '200+', label: '200+', icon: 'diversity_3' }
        ] },
        { key: 'logistics', title: 'Logistique & mobilité', options: [
          { value: 'aucune', label: 'Aucune', icon: 'do_not_disturb' },
          { value: 'livraison', label: 'Livraison ponctuelle', icon: 'local_mall' },
          { value: 'externe', label: 'Transport externe', icon: 'local_shipping' },
          { value: 'flotte', label: 'Flotte auto', icon: 'directions_car' }
        ] }
      ]
      return steps[this.assessment.step]
    },
    currentAnswer() {
      const keys = ['sector','location','buildings','data','personnel','logistics']
      const key = keys[this.assessment.step]
      return this.assessment.answers[key]
    },
    topRisks() {
      const map = {
        incendie: { title: 'Incendie', icon: 'local_fire_department', micro: "Garantie Incendie + Perte d'exploitation" },
        eaux: { title: 'Dégâts des eaux', icon: 'water_damage', micro: "Dégâts des eaux + Perte d'exploitation" },
        climat: { title: 'Climat', icon: 'cloud_queue', micro: 'Tempêtes, inondations' },
        vol: { title: 'Vol', icon: 'local_police', micro: 'Protection des biens' },
        bris: { title: 'Bris de machine', icon: 'build', micro: 'Machines et équipements' },
        rc: { title: 'Responsabilité civile', icon: 'gavel', micro: 'RC Exploitation/RC Pro' },
        employe: { title: 'Risque employé', icon: 'groups', micro: 'Accidents du personnel' },
        cyber: { title: 'Cyber', icon: 'security', micro: 'Cyber Essential' },
        transport: { title: 'Transport', icon: 'local_shipping', micro: 'Marchandises transportées' },
        fraude: { title: 'Fraude', icon: 'report', micro: 'Pertes financières' },
        chantier: { title: 'Chantier', icon: 'construction', micro: 'RC Chantier/DO/TRC' },
        exploitation: { title: "Perte d'exploitation", icon: 'trending_down', micro: 'Continuité d’activité' }
      }
      const entries = Object.entries(this.riskScores)
        .sort((a,b)=>b[1]-a[1])
        .slice(0,3)
        .map(([key])=>({ key, title: map[key].title, icon: map[key].icon, micro: map[key].micro }))
      return entries
    },
    recommendedGaranties() {
      const keys = this.topRisks.map(r=>r.key)
      const out = []
      if (keys.includes('incendie')) { out.push('Incendie'); out.push("Perte d'exploitation") }
      if (keys.includes('cyber')) { out.push('Cyber Essential') }
      if (keys.includes('rc')) { out.push('RC Exploitation'); out.push('RC Pro') }
      if (keys.includes('transport')) { out.push('Flotte/Transport') }
      if (keys.includes('bris')) { out.push('Bris de machine') }
      return Array.from(new Set(out))
    },
    recommendedPacks() {
      const keys = this.topRisks.map(r=>r.key)
      const out = []
      if (keys.includes('incendie') || keys.includes('eaux') || keys.includes('vol')) out.push('Multirisque Entreprise')
      if (keys.includes('cyber')) out.push('Cyber Essential')
      if (keys.includes('rc')) out.push('Pack RC Pro')
      if (keys.includes('transport')) out.push('Flotte Auto/Transport')
      return Array.from(new Set(out))
    }
  },
  methods: {
    toDevis(offer) {
      if (offer.devisLink) {
        window.open(offer.devisLink, '_self');
      }
    },
    openProForm() {
      this.formSubject = 'Assurance Pro'
      this.showProForm = true
    },
    openDemandeDemo() {
      this.formSubject = 'Assurance Pro'
      this.demandeDemo = true
    },
    goToContactForm(subject) {
      console.log('::::: subject :::::::', subject)
      // Route existante: /contactform/:subject
      // const safeSubject = encodeURIComponent(subject);
      // this.$router.push({ path: `/contactform/${safeSubject}` });
    },
    downloadOfferPdf(pdfUrl) {
      if (!pdfUrl) return;
      const link = document.createElement('a');
      link.href = pdfUrl;
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
      link.download = '';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    downloadQuestionnaire() {
      if (this.questionnaireUrl) {
        window.open(this.questionnaireUrl, '_blank', 'noopener,noreferrer');
      } else {
        // Fallback: demander le questionnaire via WhatsApp
        window.open(
          'https://wa.me/221761416464?text=Bonjour%20Assuraf%20Pro%20-%20je%20souhaite%20recevoir%20le%20questionnaire',
          '_blank',
          'noopener,noreferrer'
        );
      }
    },
    goToContactForm(subject) {
    console.log('::::: subject :::::::', subject)
      // Route existante: /contactform/:subject
      // const safeSubject = encodeURIComponent(subject);
      // this.$router.push({ path: `/contactform/${safeSubject}` });
    },
    downloadQuestionnaire() {
      if (this.questionnaireUrl) {
        window.open(this.questionnaireUrl, '_blank', 'noopener,noreferrer');
      } else {
        // Fallback: demander le questionnaire via WhatsApp
        window.open(
          'https://wa.me/221761416464?text=Bonjour%20Assuraf%20Pro%20-%20je%20souhaite%20recevoir%20le%20questionnaire',
          '_blank',
          'noopener,noreferrer'
        );
      }
    },
    scrollToSection(id) {
      // Priorité: chercher dans le DOM du composant pour éviter les collisions globales
      const localEl = this.$el && this.$el.querySelector(`#${id}`);
      const el = localEl || document.getElementById(id);
      if (!el) return;

      const targetY = el.getBoundingClientRect().top + window.pageYOffset;
      this.easeScrollTo(targetY, 700);

      try { history.pushState(null, '', `#${id}`); } catch (e) {}
    },
    easeScrollTo(targetY, duration = 700) {
      const startY = window.pageYOffset;
      const distance = targetY - startY;
      let startTime = null;
      const easeInOutCubic = (t) => (t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2);
      const step = (timestamp) => {
        if (!startTime) startTime = timestamp;
        const elapsed = timestamp - startTime;
        const progress = Math.min(1, elapsed / duration);
        const eased = easeInOutCubic(progress);
        window.scrollTo(0, Math.round(startY + distance * eased));
        if (progress < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    },
    openAssessment() {
      this.assessmentMode = true
      this.assessmentCompleted = false
      this.showProForm = true
      this.assessment.step = 0
      this.assessment.answers = { sector: null, location: null, buildings: null, data: null, personnel: null, logistics: null }
    },
    selectOption(value) {
      const keys = ['sector','location','buildings','data','personnel','logistics']
      const key = keys[this.assessment.step]
      this.assessment.answers[key] = value
    },
    isSelected(value) {
      const keys = ['sector','location','buildings','data','personnel','logistics']
      const key = keys[this.assessment.step]
      return this.assessment.answers[key] === value
    },
    nextOrFinish() {
      if (this.assessment.step < 5) {
        this.assessment.step += 1
      } else {
        this.finishAssessment()
      }
    },
    prevStep() {
      if (this.assessment.step > 0) this.assessment.step -= 1
    },
    finishAssessment() {
      const s = this.assessment.answers
      const scores = { incendie: 0, eaux: 0, climat: 0, vol: 0, bris: 0, rc: 0, employe: 0, cyber: 0, transport: 0, fraude: 0, chantier: 0, exploitation: 0 }
      if (s.sector === 'commerce') { scores.vol += 2; scores.rc += 1; scores.exploitation += 1 }
      if (s.sector === 'industrie') { scores.incendie += 2; scores.bris += 2; scores.rc += 1; scores.exploitation += 1 }
      if (s.sector === 'services') { scores.cyber += 3; scores.rc += 1 }
      if (s.sector === 'construction') { scores.chantier += 3; scores.rc += 2 }
      if (s.location === 'urbain') { scores.incendie += 1; scores.rc += 1 }
      if (s.location === 'cotier') { scores.climat += 3 }
      if (s.location === 'industriel') { scores.incendie += 2; scores.eaux += 1 }
      if (s.location === 'rural') { scores.climat += 1 }
      if (s.buildings === 'entrepot') { scores.incendie += 3; scores.exploitation += 2 }
      if (s.buildings === 'atelier') { scores.bris += 3; scores.exploitation += 1 }
      if (s.buildings === 'bureaux') { scores.rc += 1; scores.cyber += 1 }
      if (s.buildings === 'boutique') { scores.vol += 2; scores.incendie += 1 }
      if (s.data === 'sensible') { scores.cyber += 3 }
      if (s.data === 'standard') { scores.cyber += 2 }
      if (s.data === 'minimal') { scores.cyber += 1 }
      if (s.personnel === '1-10') { scores.employe += 1; scores.rc += 1 }
      if (s.personnel === '11-50') { scores.employe += 2; scores.rc += 1 }
      if (s.personnel === '51-200') { scores.employe += 3; scores.rc += 2 }
      if (s.personnel === '200+') { scores.employe += 4; scores.rc += 2 }
      if (s.logistics === 'flotte') { scores.transport += 3; scores.rc += 1 }
      if (s.logistics === 'livraison') { scores.transport += 2 }
      if (s.logistics === 'externe') { scores.transport += 1 }
      const total = Object.values(scores).reduce((a,b)=>a+b,0)
      let label = 'Faible'
      if (total >= 8 && total < 16) label = 'Modéré'
      if (total >= 16) label = 'Élevé'
      this.riskScores = scores
      this.riskProfileLabel = label
      this.assessmentCompleted = true
    },
    convertDevis() {
      this.assessmentMode = false
      this.formSubject = 'Assurance Pro'
      this.showProForm = true
    },
    convertCallback() {
      window.open('https://wa.me/221761416464?text=Bonjour%20Assuraf%20-%20je%20souhaite%20etre%20rappelle%20pour%20mon%20profil%20de%20risques','_blank','noopener,noreferrer')
    },
    downloadRecommendation() {
      window.print()
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../assets/less/config";
@import "../../assets/css/button.css";

/* Structure et SEO */
.page-title {
  font-weight: 700;
  font-size: 40px;
  color: #fff;
  margin: 0;
}
.page-subtitle {
  color: #fff!important;
  font-size: 18px;
  margin-top: 10px;
}
.hero {
  position: relative;
  background: linear-gradient(135deg, #0d4e78 0%, #173b59 100%);
  min-height: 350px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px 0;
}
.hero .content_home {
  position: relative;
  min-height: 180px;
  width: 100%;
  max-width: 1200px;
  z-index: 2;
  margin-left: 9.5%;
  margin-right: 9.5%;
  margin-top: 5%;
}
.hero-overlay {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.15);
}
.cta-group {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  margin-top: 18px;
  margin-left: -10px;
}
.cta-btn {
  text-transform: none;
  font-weight: 500;
  border-radius: 10px;
}
.anchor-nav {
  display: flex;
  flex-wrap: wrap;
  gap: 18px;
  margin-top: 20px;
}
.anchor-link {
  color: #fff;
  font-weight: 500;
  text-decoration: none;
  padding: 6px 10px;
  border-radius: 6px;
}
.anchor-link:hover {
  text-decoration: underline;
}
.section {
  padding: 50px 0;
  background: #fff;
  scroll-margin-top: 12px;
}
.section-gray {
  background: #f5f6f6;
}
.section-header {
  text-align: center;
  margin-bottom: 24px;
}
.section-header h2 {
  color: #2b2b2b;
  font-size: 26px;
  font-weight: bold;
}
.underline_bar {
  height: 4px;
  width: 150px;
  background: #ffa409;
  margin: 12px auto 0;
}
.margin {
  margin-left: 8%;
  margin-right: 8%;
}
.benefit-card {
  background: #fff;
  border-radius: 8px;
  padding: 18px;
  margin: 10px 0;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.08);
  transition: transform 240ms ease, box-shadow 240ms ease;
  animation: fadeSlideIn 500ms ease both;
}
.benefit-card .v-icon {
  font-size: 34px;
  margin-bottom: 6px;
  transition: transform 240ms ease, color 240ms ease;
}
.benefit-card h3 {
  font-size: 16px;
  margin: 10px 0 6px;
  color: #0d4e78;
}
.benefit-card p {
  color: #444;
  font-size: 14px;
}
.benefit-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 24px rgba(13, 78, 120, 0.12);
}
.benefit-card:hover .v-icon { transform: scale(1.06) rotate(-3deg); color: #ffa409; }

@keyframes fadeSlideIn {
  from { opacity: 0; transform: translateY(8px); }
  to   { opacity: 1; transform: translateY(0); }
}
/* Delais progressifs pour les 3 cartes de la section Pourquoi */
#why .margin .v-flex:nth-child(1) .benefit-card { animation-delay: 60ms; }
#why .margin .v-flex:nth-child(2) .benefit-card { animation-delay: 140ms; }
#why .margin .v-flex:nth-child(3) .benefit-card { animation-delay: 220ms; }
.offer-card {
  border-radius: 14px;
  overflow: hidden;
  border: 1px solid #edf0f3;
  transition: box-shadow 200ms ease, transform 200ms ease;
  box-shadow: 0 12px 24px rgba(13, 78, 120, 0.15);
}
.offer-card:hover {
  box-shadow: 0 12px 24px rgba(13, 78, 120, 0.12);
  transform: translateY(-2px);
}
.offer-header {
  background: linear-gradient(135deg, #0d4e78 0%, #173b59 100%);
  padding: 16px;
  display: flex;
  align-items: center;
}
.offer-icon {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
}
.offer-name {
  color: #fff;
  font-weight: 600;
  font-size: 16px;
}
.offer-text {
  color: #444;
  padding: 16px;
  min-height: 84px;
}
.offer-actions {
  padding: 16px;
  display: flex;
  gap: 12px;
  justify-content: space-between;
  align-items: stretch;
}
.offer-btn {
  flex: 1;
  border-radius: 10px !important;
  text-transform: none;
  font-weight: 400;
}
.offer-btn-primary {
  /* orange plein par défaut via color */
}
.offer-btn-secondary {
  color: #fff;
  /* outlined bleu pour hiérarchie visuelle */
}

/* xs breakpoint */
@media (max-width: 768px) {
  .offer-actions { flex-direction: column; gap: 10px; padding: 14px; }
  .offer-btn { width: 100%; }
}
  .offer-text { min-height: auto; padding: 14px; }
  .contact-card { padding: 16px; }

/* very small devices */
@media (max-width: 480px) {
  .page-title { font-size: 24px; }
  .page-subtitle { font-size: 15px; }
  .offer-header { padding: 12px; }
  .offer-icon { width: 34px; height: 34px; margin-right: 10px; }
  .offer-name { font-size: 14px; }
  .offer-text { font-size: 14px; padding: 12px; }
  .benefit-card h3 { font-size: 15px; }
  .benefit-card p { font-size: 13px; }
}


/* Hero moderne (clair, inspiré du design fourni) */
.hero-modern {
  background:
    radial-gradient(1200px 600px at 70% 0%, #000000d3 0%, rgba(237, 162, 10, 0) 60%),
    radial-gradient(900px 500px at 15% 70%, #000000d3 0%, rgba(240,231,255,0) 60%),
    #000000d3;
  min-height: 560px;
  padding: 64px 0;
}
.hero-modern .content_home {
  margin-left: 9.5%;
  margin-right: 9.5%;
  max-width: 1200px;
}
.hero-modern .hero-overlay { background: none; }

/* Titres et accent en dégradé (bleu -> violet) */
.page-title-gradient {
  background: linear-gradient(90deg, #fff 0%, #fff 40%, #fff 65%, #fff 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-weight: 800;
  font-size: 52px;
  line-height: 1.1;
}
.accent {
  background: linear-gradient(90deg, #fcb73f 0%, #ffa409 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.hero-modern .page-subtitle {
  color: #334155;
  font-size: 18px;
  max-width: 720px;
  margin-top: 14px;
}

/* CTA pilules, ombres douces */
.cta-primary {
  border-radius: 10px;
  padding: 12px 20px;
  box-shadow: 0 8px 24px rgba(255, 164, 9, 0.25);
}
.cta-primary-white {
  background: transparent !important;
  color: #ffa409 !important;
  border: 2px solid #ffa409 !important;
  border-radius: 10px !important;
  padding: 14px 24px !important;
  box-shadow: 0 8px 24px rgba(255, 164, 9, 0.25) !important;
}
.cta-ghost {
  border-radius: 10px;
  padding: 12px 20px;
  background: rgba(255, 255, 255, 0.6);
  backdrop-filter: blur(6px);
}

/* Chips d’ancrage style “glass” */
.anchor-chips .anchor-link {
  color: #0f172a;
  background: rgba(255,255,255,0.8);
  border: 1px solid rgba(15, 23, 42, 0.08);
  border-radius: 999px;
  padding: 8px 12px;
}
.anchor-chips .anchor-link:hover {
  background: rgba(255,255,255,0.95);
  text-decoration: none;
}

/* Glow shapes (taches floues) */
.hero-shape {
  position: absolute;
  filter: blur(24px);
  z-index: 1;
}
.hero-bg-image {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: 0.3;
  z-index: 0;
}
// .shape-1 {
//   width: 560px;
//   height: 560px;
//   right: -140px;
//   top: -160px;
//   background: radial-gradient(closest-side, rgba(238, 175, 1, 0.35), rgba(250, 174, 21, 0));
// }
// .shape-2 {
//   width: 460px;
//   height: 460px;
//   left: -120px;
//   bottom: -140px;
//   background: radial-gradient(closest-side, rgba(238, 175, 1,0.25), rgba(250, 174, 21,0));
// }

/* Responsive */
@media (max-width: 992px) {
  .page-title-gradient { font-size: 44px; }
}
@media (max-width: 768px) {
  .hero-modern { min-height: 420px; padding: 48px 0; }
  .page-title-gradient { font-size: 34px; }
  .hero-modern .content_home { margin-left: 5%; margin-right: 5%; margin-top: 15%;}
  .anchor-chips { gap: 10px; }
}
@media (max-width: 480px) {
  .page-title-gradient { font-size: 28px; }
}

.contact-card {
  background: #fff;
  border-radius: 12px;
  padding: 20px;
  border: 1px solid #edf0f3;
  box-shadow: 0 8px 20px rgba(13, 78, 120, 0.08);
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  min-height: 120px;
}

.contact-card .v-icon {
  font-size: 28px;
  margin-bottom: 8px;
}

.contact-card h3 {
  color: #0d4e78;
  font-size: 16px;
  font-weight: 600;
  margin: 6px 0 8px;
}

.contact-card p {
  color: #667085;
  font-size: 14px;
  margin: 0;
}

.contact-card a {
  color: #0d4e78;
  text-decoration: none;
  font-weight: 500;
}

.contact-card a:hover {
  text-decoration: underline;
}

/* Responsive ajusté pour garder l’équilibre */
@media (max-width: 768px) {
  .contact-card {
    padding: 16px;
    min-height: auto;
  }
}
/* Amélioration des CTA sur mobile (≤480px) */
@media (max-width: 480px) {
  /* Boutons dans les cartes d’offres */
  .offer-actions { padding: 16px; }
  .offer-btn {
    width: 100%;
    min-height: 38px;
    font-size: 16px;
    font-weight: 400;
    border-radius: 12px !important;
  }
  .offer-btn-primary {
    box-shadow: 0 6px 14px rgba(255, 164, 9, 0.30);
  }

  /* Boutons du bandeau (hero) */
  .cta-group { justify-content: center; margin-left: 0; }
  .cta-group .v-btn {
    width: 90%;
    max-width: 320px;
    min-height: 48px;
    font-size: 16px;
    border-radius: 12px;
    margin: 0 auto;
  }
  /* CTA dans la section risques */
  #risks .cta-primary-white {
    display: block;
    width: 90%;
    max-width: 320px;
    min-height: 48px;
    margin: 0 auto;
    border-radius: 12px;
  }
}






 ::placeholder {
    /* Chrome, Firefox, Opera, Safari 10.1+ */
    font-size: 12px;
  }
.pro-form-card {
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 10px 24px rgba(13, 78, 120, 0.15);
  padding: 20px;
  max-width: 880px;
  width: 100%;
  margin: 0 auto;
}

.pro-form-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 12px;
  border-bottom: 1px solid rgba(13, 78, 120, 0.12);
  margin-bottom: 16px;
}

.header-left {
  display: flex;
  align-items: center;
}

.titles .title {
  margin: 0;
  font-size: 18px;
  color: #0d4e78;
  font-weight: 700;
  line-height: 1.2;
}

.titles .subtitle {
  margin: 2px 0 0;
  font-size: 13px;
  color: #6b7c8a;
}

.badge {
  font-size: 12px;
  color: #0d4e78;
  background: rgba(13, 78, 120, 0.08);
  border: 1px solid rgba(13, 78, 120, 0.14);
  padding: 6px 10px;
  border-radius: 999px;
  display: inline-flex;          /* assure l’alignement vertical */
  align-items: center;
}

.close-icon {
  margin-left: 0;                /* neutralise l’ancienne marge ml-3 */
}

@media (max-width: 768px) {
  .badge {
    font-size: 11px;             /* compacte le badge sur petits écrans */
    padding: 6px 8px;
  }
  .header-right {
    gap: 8px;                    /* réduit l’espace pour tenir à côté */
  }
}
.header-right {
  display: inline-flex;          /* aligne badge et icône sur une ligne */
  align-items: center;
  gap: 10px;                     /* espace entre badge et X */
  white-space: nowrap;           /* évite le retour à la ligne sur mobile */
}

.badge {
  font-size: 12px;
  color: #0d4e78;
  background: rgba(13, 78, 120, 0.08);
  border: 1px solid rgba(13, 78, 120, 0.14);
  padding: 6px 10px;
  border-radius: 999px;
  display: inline-flex;          /* assure l’alignement vertical */
  align-items: center;
}

.close-icon {
  margin-left: 0;                /* neutralise l’ancienne marge ml-3 */
}

@media (max-width: 768px) {
  .badge {
    font-size: 11px;             /* compacte le badge sur petits écrans */
    padding: 6px 8px;
  }
  .header-right {
    gap: 8px;                    /* réduit l’espace pour tenir à côté */
  }
}






.risk-card {
  border-radius: 12px;
  border: 1px solid #edf0f3;
  background: #fff;
  padding: 16px;
  box-shadow: 0 8px 18px rgba(13, 78, 120, 0.10);
  transition: transform 240ms ease, box-shadow 240ms ease;
  animation: fadeSlideIn 500ms ease both;
}
.risk-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 6px;
}
.risk-title {
  color: #0d4e78;
  font-weight: 600;
  font-size: 16px;
}
.risk-text {
  color: #444;
  font-size: 14px;
}

.risk-card:hover { transform: translateY(-4px); box-shadow: 0 12px 24px rgba(13, 78, 120, 0.12); }
.risk-card:hover .v-icon { transform: scale(1.06) rotate(-3deg); color: #ffa409; }

#risks .margin .v-flex:nth-child(1) .risk-card { animation-delay: 60ms; }
#risks .margin .v-flex:nth-child(2) .risk-card { animation-delay: 120ms; }
#risks .margin .v-flex:nth-child(3) .risk-card { animation-delay: 180ms; }
#risks .margin .v-flex:nth-child(4) .risk-card { animation-delay: 240ms; }
#risks .margin .v-flex:nth-child(5) .risk-card { animation-delay: 300ms; }
#risks .margin .v-flex:nth-child(6) .risk-card { animation-delay: 360ms; }
#risks .margin .v-flex:nth-child(7) .risk-card { animation-delay: 420ms; }
#risks .margin .v-flex:nth-child(8) .risk-card { animation-delay: 480ms; }
#risks .margin .v-flex:nth-child(9) .risk-card { animation-delay: 540ms; }
#risks .margin .v-flex:nth-child(10) .risk-card { animation-delay: 600ms; }
#risks .margin .v-flex:nth-child(11) .risk-card { animation-delay: 660ms; }
#risks .margin .v-flex:nth-child(12) .risk-card { animation-delay: 720ms; }

// .assessment { padding: 20px; }
.assessment-card { padding: 24px; }
.assessment-title { color: #0d4e78; font-size: 18px; font-weight: 700; margin-bottom: 12px; }
.assessment-subtitle { color: #667085; font-size: 14px; margin-bottom: 8px; }
.assessment-body { margin-top: 12px; }
.assessment-question-title { font-size: 16px; font-weight: 600; color: #1f2937; margin-bottom: 10px; }
.assessment-options { display: flex; flex-wrap: wrap; gap: 10px; }
.assessment-chip { border-radius: 999px !important; background: rgba(13,78,120,0.06); }
.chip-selected { background: #ffa409 !important; color: #000 !important; border-color: #ffa409 !important; }
.assessment-actions { display: flex; gap: 10px; margin-top: 16px; }
.assessment-btn { border-radius: 10px !important; min-width: 160px; }
.assessment-btn-primary { box-shadow: 0 6px 16px rgba(255,164,9,0.35); }
.assessment-btn-secondary { color:#fff}
.assessment-btn-next { background: transparent !important; color: #1f2937 !important; box-shadow: none !important; font-weight: 600; }
.assessment-results-title { color: #0d4e78; font-size: 18px; font-weight: 700; margin: 12px 0; }
.results-grid { display: grid; grid-template-columns: 1fr; gap: 16px; }
.result-title { font-size: 16px; font-weight: 600; color: #1f2937; }
.result-cards { display: grid; grid-template-columns: 1fr; gap: 10px; }
.result-card { border: 1px solid #edf0f3; border-radius: 10px; padding: 12px; background: #fff; }
.result-card-header { display: flex; align-items: center; gap: 8px; margin-bottom: 6px; }
.result-card-title { color: #0d4e78; font-weight: 600; }
.result-card-text { color: #444; font-size: 14px; }
.chips { display: flex; flex-wrap: wrap; gap: 8px; }
@media (min-width: 768px) {.result-cards { grid-template-columns: 1fr 1fr 1fr; } }

/* Boutons wizard (évaluation rapide) */
.wizard-btn { display: inline-flex; align-items: center; gap: 6px; background: transparent; border: none; color: #1f2937; padding: 10px 12px; border-radius: 10px; cursor: pointer; }
.wizard-btn[disabled] { opacity: 0.5; cursor: not-allowed; }
.next-btn { font-weight: 600; }
.next-btn-active { color: #ffa409 !important; }

/* Responsivité des actions en bas (wizard + résultats) */
@media (max-width: 600px) {
  .assessment-actions { gap: 10px; position: sticky; bottom: 0; background: #ffffff; padding: 12px 0 calc(12px + env(safe-area-inset-bottom)); border-top: 1px solid rgba(13,78,120,0.08); }
  .wizard-actions { flex-direction: row; flex-wrap: nowrap; align-items: center; justify-content: space-between; }
  .result-actions { flex-direction: column; align-items: center; }
  .assessment-actions .v-btn,
  .assessment-actions .wizard-btn { width: auto; min-width: 140px; justify-content: center; min-height: 44px; }
  .result-actions .v-btn { width: 100%; max-width: 320px; }
  .assessment-actions .v-spacer, .assessment-actions .spacer { display: none !important; }
  .assessment-card { padding: 16px; padding-bottom: calc(24px + env(safe-area-inset-bottom)); }
  .assessment-title { font-size: 18px; }
  .assessment-subtitle { font-size: 12px; }
  .assessment-header { margin-bottom: 8px; }
  .assessment-options { display: grid; grid-template-columns: 1fr 1fr; gap: 10px; }
  .assessment-chip { justify-content: center; min-height: 40px; }
  .wizard-btn { font-size: 16px; }
}
</style>
